var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { ReleaseOneViewSkeleton } from '@/components/pages/release/ReleaseOneView';
import Layout from '@/container/Layout';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { ReleaseOnePage } from '@/pages/release/ReleaseOne/ReleaseOnePage';
import { useReleaseOneFetch } from '@/pages/release/ReleaseOne/useReleaseOneFetch';
import { isGuest } from '@/utils/resources/auth/authResource';
import { releaseListPath } from '@/utils/router/links';
/**
 * ニュース詳細（データ取得, 認証以外のアクセス制限）
 * @param props
 * @returns
 */
export const ReleaseOne = (props) => {
    var _a;
    const { match } = props;
    const { auth } = useTypeSelector((state) => state);
    const isGuestUser = isGuest(auth);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const id = parseInt(((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.id) || '', 10);
    // ニュース詳細データ取得, ページ状態管理
    const { fetchReleaseOne, loading, releaseOneData } = useReleaseOneFetch({
        dispatch,
        unmountRef,
    });
    // 表示中のニュース詳細のデータ
    const currentReleaseOneData = releaseOneData === null || releaseOneData === void 0 ? void 0 : releaseOneData[id];
    // データ取得実行
    useEffect(() => {
        if (!currentReleaseOneData) {
            ;
            (() => __awaiter(void 0, void 0, void 0, function* () {
                yield fetchReleaseOne(id);
            }))();
        }
    }, [currentReleaseOneData, fetchReleaseOne, id]);
    // ローディング表示
    if (loading && !currentReleaseOneData) {
        return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(ReleaseOneViewSkeleton, { isGuestUser: isGuestUser }) })));
    }
    // リダイレクト: ニュース一覧
    if (!currentReleaseOneData) {
        return _jsx(CustomRedirect, { to: releaseListPath() });
    }
    return (_jsx(ReleaseOnePage, { isGuestUser: isGuestUser, releaseOneData: currentReleaseOneData }));
};
